import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import config from "config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [region, setRegion] = useState(() => localStorage.getItem("region") || "INDIA");

  const updateRegion = (value) => {
    localStorage.setItem("region", value);
    setRegion(value);
  };

  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${config.BACKEND_API_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const res = await response.json();

      if (res.success) {
        setUser(res.data);
      } else if (res.message === "Invalid token." || res.message === "No token provided.") {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch user on initial mount
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <UserContext.Provider value={{ user, setUser, loading, setLoading, region, updateRegion, refreshUser: fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
export const useAuth = () => useContext(UserContext);
